<template>
  <w-vue-select
    v-bind="{ ...$props, ...$attrs }"
    :title="title"
    :model="$schema.value"
    :values="values"
    :label-field="options.labelField"
    :value-field="options.valueField"
    :input-id="inputId"
    :taggable="options.taggable"
    @input="updateValue"
    @search="search"
  />
</template>

<script>
import { formMixin } from '@/mixins/form';

const DEFAULT_VALUE_TYPE = 'string';

const schema = (type = DEFAULT_VALUE_TYPE) => ({
  properties: {
    value: { items: { type }, type: 'array' }
  }
});

// @vuese
// Multiselect bez schemy
// @group Form
export default {
  mixins: [formMixin],
  schema: schema(),
  props: {
    // Wartość
    value: { type: Array },
    // Typ wartości
    valueType: { type: String, default: DEFAULT_VALUE_TYPE },
    // Wyświetlany tytuł
    title: { type: String, default: '' },
    // Opcje
    options: { type: Object, required: false },
    // Wartość atrybutu id inputa
    inputId: { type: String, required: false }
  },
  data() {
    return { model: {}, values: this.options.values || [] };
  },
  watch: {
    value(newValue) {
      this.setSchemaData(newValue);
    }
  },
  mounted() {
    this.prepareSchema();
    this.setSchemaData(this.value);
    this.search();
  },
  methods: {
    // @vuese
    // Przygotowuje schemę do użycia
    prepareSchema() {
      if (this.valueType !== DEFAULT_VALUE_TYPE) {
        this.$setSchema(schema(this.valueType));
        this.$schema.$reset();
      }
    },
    // @vuese
    // Ustawia wartość w schemie i tym samym na widoku
    setSchemaData(value) {
      if (value === this.$schema.value.$model) {
        return;
      }

      if (!value) {
        this.$schema.value.$setData([], undefined, true);
      } else {
        this.$schema.value.$setData(value, undefined, true);
      }
    },

    // @vuese
    // Ustawia wartość modelu przez emit eventu `input`
    updateValue(newValue) {
      this.$emit('input', newValue);
    },

    // @vuese
    // Wyszukuje pasujące elementy
    search(search) {
      if (this.options?.action) {
        this.$store.dispatch(this.options.action, { ...this.options.actionParams, search }).then(result => {
          if (result.list) {
            result = result.list;
          }
          this.values = result;
        });
      }
    }
  }
};
</script>
